import { Box, Divider, Grid, Typography } from "@mui/material";
import { MapaDoBrasil } from "./mapa-brasil";
import { theme } from "../../../../styles";
import { ProjetosRecentes } from "./projetos-recentes";
import { useUIService } from "../../../../../use-cases/ui";
import { useEffect } from "react";

export const PaginaInicial = () => {
  const { changeTitleAndMetaDesc, setActivePage } = useUIService();

  useEffect(() => {
    changeTitleAndMetaDesc({
      title: "Veles_Geo - Página Inicial",
      metaDesc:
        "Página inicial da plataforma Veles_Geo. Um sistema do Grupo Veles.",
    });

    setActivePage({ pageKey: "Geo-Veles/" });
  }, [changeTitleAndMetaDesc, setActivePage]);

  return (
    <>
      <Box
        p={3}
        display="flex"
        flexGrow={1}
        height={"100%"}
        overflow={"hidden"}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="h6"
              color="primary"
              fontWeight="bold"
              textTransform={"uppercase"}
              textAlign={"center"}
            >
              Detalhamento
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="h6"
              color="primary"
              fontWeight="bold"
              textTransform={"uppercase"}
              textAlign={"center"}
            >
              Projetos recentes - top 5
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider color={theme.palette.primary.main} />
          </Grid>
          <Grid item xs={6}>
            <MapaDoBrasil />
          </Grid>
          <Grid item xs={6}>
            <ProjetosRecentes />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
